module.exports = __webpack_public_path__ + "static/media/promo.4f271be1.mp4";